import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { $requestToken } from '../../../utils/apis'
import { getIJoistManufacturer } from '../../../utils/actions'
import { MEMBER_MANUFACTURER_PRODUCTS } from '../../../utils/constants'

import PageView from '../containers/PageView'

const App = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    $requestToken().then(() => {
      dispatch(getIJoistManufacturer({ member: MEMBER_MANUFACTURER_PRODUCTS.RAFTER }))
    })
  }, [])

  return <PageView />
}

export default App
